import { injectReducer } from '../../store/reducers';

export default store => (
  {
    path: 'tours',
    childRoutes: [
      {
        path: ':id(/:key(/:detail(/:detailSelect)))',
        getComponent(nextState, cb) {
          const TourDetailContainer = require('./containers/TourDetailContainer').default; // eslint-disable-line global-require
          const reducer = require('./modules/tour').default; // eslint-disable-line global-require
          injectReducer(store, { key: 'tours', reducer });

          cb(null, TourDetailContainer);
        },
      },
    ],
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Tours = require('./containers/ToursContainers').default;
      const reducer = require('./modules/tour').default;

      injectReducer(store, { key: 'tours', reducer });

      /*  Return getComponent   */
      cb(null, Tours);
    },
  }
);



// WEBPACK FOOTER //
// src/routes/tours/Tours.js